import moment from "moment";
import { useEffect, useState } from "react";
import { UserApi } from "../../api/User.api";
import PasswordResetModal from "../../components/me/PasswordReset.modal";
import SubscriptionCancelModal from "../../components/me/SubscriptionCancel.modal";
import WithdrawalModal from "../../components/me/Withdrawal.modal";
import PaymentHistory from "../../models/PaymentHistory.model";
import UserSubscription from "../../models/UserSubscription.model";
import { useAppDispatch, useAppSelector } from "../../store";
import { setSignOut, setUser } from "../../store/modules/app";
import { Container } from "./style";
import { addComma } from "../../utils/Utils";
import ProgressView from "../../components/commons/Progress.view";
import Error from "../../models/Error.model";
import { ERROR_TYPE, PAYMENT_STATUS, Products } from "../../commons/Const";
import { Storage } from "../../utils/Storage";
import { useNavigate } from "react-router-dom";
import ChangeSubscriptionModal from "../../components/me/ChangeSubscription.modal";
import { isMobile } from "react-device-detect";
import TextFieldView from "../../components/commons/TextField.view";
import MeViewModel from "./me.viewmodel";


export default function MePage() {

  const viewModel = MeViewModel();

  const user = viewModel.user;

  if(user === undefined || user === null) return <></>

  return (
    <>
      <Container>
        <div className="inner page_inner">
          <p className="page_title"><span>내 정보</span></p>

          <section>
            <p className="section_title"><span>기본 정보</span></p>

            <div className="row">
              <p className="form_label_row">이름</p>
              <p>{user.name}</p>
            </div>

            <div className="row">
              <p className="form_label_row">연락처</p>
              <p>{user.phone}</p>
            </div>

            {user.loginType === 'email' && (
              <div className="row">
                <p className="form_label_row">아이디</p>
                <p>{user.uid}</p>
              </div>
            )}

            {user.loginType === 'email' && (
              <div className="row">
                <p className="form_label_row">비밀번호</p>
                <button className="outlined_gray"
                  onClick={e => viewModel.setShowResetPasswordModal(true)}
                >비밀번호 변경</button>
              </div>
            )}

            <div className="row coupon">
              <p className="form_label_row">쿠폰{viewModel.coupon === null && '번호 입력'}</p>
              <div className="row_right">
                {viewModel.coupon === null && (
                  <div className="coupon_input_bx">
                    <TextFieldView
                      type="text"
                      placeholder="쿠폰번호"
                      value={viewModel.couponCode}
                      onChange={viewModel.setCouponCode}
                    />
                    <button
                      className="contained_main"
                      onClick={viewModel.registerCoupon}
                    >등록</button>
                  </div>
                )}
                {viewModel.coupon !== null && (
                  <>
                  <div className={`cuopon_bx ${viewModel.coupon.usedAt !== null ? 'used' : ''}`}>
                    <p>{viewModel.coupon.coupon.name}</p>
                    <p>{addComma(viewModel.coupon.coupon.value)}</p>
                  </div>
                  {viewModel.coupon.usedAt !== null && (
                    <p className="used_msg">사용완료 ({moment(viewModel.coupon.usedAt).format('YYYY.MM.DD HH:mm')})</p>
                  )}
                  </>
                )}
              </div>
            </div>

            <button className="btn_withdrawal flex ai-c"
              onClick={e => viewModel.setShowWithdrawal(true)}
            >
              <span className="gray_5">회원 탈퇴</span>
              <span className="ic" />
            </button>

            {viewModel.enableChangeSubscription && (
              <button className="btn_change flex ai-c"
                onClick={e => viewModel.setShowChangeSubscription(true)}
              >
                <span className="gray_5">월 자문료 변경</span>
                <span className="ic" />
              </button>
            )}
          </section>

          {viewModel.subscription && (
            <section className="subscribe">
              <div className={`section_title ${!isMobile ? 'flex ai-c jc-sb': ''}`}>
                <span>구독 정보</span>
                <div className="subscribe_status flex ai-c">
                  <p className="green_dark1">{viewModel.latestPaymentHistory ? `${viewModel.latestPaymentHistory.startRound + user.additionalMonths}회차 ` : ''}구독중{viewModel.failReason !== null ? `(결제실패, ${viewModel.failReason})` : ''}</p>
                  {(viewModel.failReason !== null) && (
                    <button 
                      onClick={viewModel.rePayment}
                    className="contained_red">재결제</button>
                  )}
                </div>
              </div>
                
              <div className="row">
                <p className="form_label_row">결제 금액</p>
                <p>{addComma(viewModel.paymentHistoryList.find(v => v.status === PAYMENT_STATUS.SUCCESS)?.amount ?? 0)} 원</p>
              </div>

              {viewModel.latestPaymentHistory?.status !== PAYMENT_STATUS.FAILED && (
                <>
                  <div className="row">
                    <p className="form_label_row">결제 일시</p>
                    <p>{moment(viewModel.latestPaymentHistory?.paidAt).format('YYYY.MM.DD HH:mm:ss')}</p>
                  </div>

                  <div className="row">
                    <p className="form_label_row">이용 기간</p>
                    <p>{viewModel.startDate} ~ {viewModel.endDate}</p>
                  </div>
                  <div className="row">
                    <p className="form_label_row">다음 결제일</p>
                    <p>{viewModel.nextDate} / {addComma(viewModel.nextAmount)}원</p>
                  </div>
                </>
              )}

              {/* {subscription.cardName !== null && (
                <div className="row">
                  <p className="form_label_row">결제 정보</p>
                  <p>{subscription.payMethod === 0 ? `${subscription.cardName ?? ''}` : '휴대폰결제'}</p>
                </div>
              )} */}

              <div className="flex group_btn">
                <button className="btn_payment_info flex ai-c"
                  onClick={viewModel.changePaymentInfo}
                >
                  <span className="gray_5">결제정보 변경</span>
                  <span className="ic" />
                </button>

                {(viewModel.latestPaymentHistory !== undefined && viewModel.latestPaymentHistory.product !== '특별 자문료') && (
                  <button className="btn_subscription_cancel flex ai-c"
                    onClick={e => viewModel.setShowSubscriptionCancel(true)}
                  >
                    <span className="gray_5">구독 취소</span>
                    <span className="ic" />
                  </button>
                )}
              </div>
            </section>
          )}
        </div>
      </Container>

        {viewModel.showResetPasswordModal && (
          <PasswordResetModal 
            onClickCancel={() => viewModel.setShowResetPasswordModal(false)}
            onSuccess={() => viewModel.setShowResetPasswordModal(false)}
          />
        )}

        {viewModel.showWithdrawal && (
          <WithdrawalModal
            onClickCancel={() => viewModel.setShowWithdrawal(false)}
            onClickConfirm={viewModel.withdrawal}
          />
        )}

        {viewModel.showChangeSubscription && (
          <ChangeSubscriptionModal
            onClickCancel={() => viewModel.setShowChangeSubscription(false)}
            onClickConfirm={viewModel.changeSubscription}
          />
        )}

        {viewModel.showSubscriptionCancel && (
          <SubscriptionCancelModal
            onClickCancel={() => viewModel.setShowSubscriptionCancel(false)}
            onClickConfirm={viewModel.cancelSubscription}
          />
        )}

        {viewModel.showLoading && <ProgressView/>}
    </>
  )
}